<template>
  <div>
    <h2 class="pdp-section-header font-weight-bold">
      At-a-glance
    </h2>

    <div class="at-glance-list mt-4">
      <ProductsAtGlanceItem
        v-for="attribute in mappedAttributes"
        :key="attribute.slug"
        :title="attribute.name"
        :slug="attribute.slug"
        :icon="attribute.icon"
        :children="attribute.values"
        class="at-glance-item"
      />
    </div>
  </div>
</template>

<script>
import { ATTRIBUTE_TYPE, ATTRIBUTE_ICON } from '../../../constants/global';
import ProductsAtGlanceItem from './ProductsAtGlanceItem.vue';

export default {
  components: {
    ProductsAtGlanceItem,
  },
  props: {
    attributes: {
      type: Array,
      required: true,
    },
  },
  created() {
    // assign icon and handle boolean types.
    // we don't need a reactive list, so we just create a constant Vue
    this.mappedAttributes = this.attributes.map((x) => {
      const attribute = { ...x };

      attribute.icon = ATTRIBUTE_ICON[attribute.slug];

      if (attribute.type === ATTRIBUTE_TYPE.BOOLEAN) {
        attribute.values = [];
      }

      return attribute;
    });
  },
};
</script>

<style lang="scss">
@import '~/styles/utils/breakpoints';

.at-glance-list .at-glance-item {
  margin-bottom: 1.5rem;

  &:last-child {
    margin-bottom: 0;
  }
}

@include media-breakpoint-up(md) {
  .at-glance-list {
    column-count: 2;
    column-gap: 2.5rem;
    max-width: 40rem;

    .at-glance-item {
      break-inside: avoid-column;
    }
  }
}
</style>
